import axios from 'axios';

export interface UsersServicesInterface {
  email?: string;
  token?: string;
}

const BASE = '/api/v1.0/users';

const UsersServices = {
  verify({ email = '', token = '', orderNo = '' }: { email: string; token: string; orderNo: string }): Promise<any> {
    const URL = `${BASE}/verifyEmail`;
    return axios.post(URL, { data: { email, token, orderNo } });
  },
  forget(): Promise<any> {
    const URL = `${BASE}/forget`;
    return axios.get(URL, {});
  },
};

export default UsersServices;
